import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ItemCard from '../components/ItemCard';
import api from '../api';
import './CameraPage.css';

const categoryMap = {
    'Canon': 148,
    'Sony': 157,
    'Nikon': 153
};

// If the user chooses "All", we fetch all camera categories
const ALL_CAMERA_IDS = [148, 157, 153];

const CameraPage = () => {
    const [items, setItems] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');  // <-- NEW state for search
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const brand = params.get('brand') || 'All'; // default to All

    useEffect(() => {
        const fetchCameras = async () => {
            setLoading(true);
            setError(null);

            try {
                let fetchedItems = [];

                if (brand === 'All') {
                    // Fetch from multiple categories, then merge
                    const requests = ALL_CAMERA_IDS.map(catId => api.get(`/items/category/${catId}`));
                    const responses = await Promise.all(requests);
                    // Flatten all responses
                    fetchedItems = responses.flatMap(r => r.data);
                } else {
                    // Single brand
                    const categoryId = categoryMap[brand] || categoryMap['Canon'];
                    const response = await api.get(`/items/category/${categoryId}`);
                    fetchedItems = response.data;
                }
                console.log("Fetched items:", fetchedItems);

                // Remove duplicates by `itemId`
                const seen = new Map();
                for (const i of fetchedItems) {
                    if (!seen.has(i.itemId)) {
                        seen.set(i.itemId, i);
                    }
                }
                setItems([...seen.values()]);
            } catch (err) {
                console.error(err);
                setError('Failed to fetch cameras');
            } finally {
                setLoading(false);
            }
        };

        fetchCameras();
    }, [brand]);

    // -- Filter items by searchTerm --
    const sTerm = searchTerm.toLowerCase().trim();
    const finalFilteredItems = items
        .filter(item => !item.hidden) // already in your code
        .filter(item => {
            if (!sTerm) return true;  // if no searchTerm, show all

            const desc = (item.description || '').toLowerCase();
            const upc = (item.upc || '').toLowerCase();
            const ean = (item.ean || '').toLowerCase();
            const customSku = (item.customSku || '').toLowerCase();
            const manufacturerSku = (item.manufacturerSku || '').toLowerCase();

            return (
                desc.includes(sTerm) ||
                upc.includes(sTerm) ||
                ean.includes(sTerm) ||
                customSku.includes(sTerm) ||
                manufacturerSku.includes(sTerm)
            );
        });

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="camera-page-container">
            {/* Header row with search + title */}
            <div className="camera-header">
                <h1>
                    {brand === 'All' ? 'All Cameras' : `${brand} Cameras`}
                </h1>
                <input
                    type="text"
                    placeholder="Description or SKU..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="camera-search-input"
                />
            </div>

            <div className="items-grid">
                {finalFilteredItems.map(item => (
                    <ItemCard key={item.itemId} item={item} />
                ))}
            </div>
        </div>
    );
};

export default CameraPage;